import apiService from './apiService';

const clean = (params) => Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
);

export const auditService = {
    search: (params) => apiService.get('/audit', clean(params)),
    getEventTypes: () => apiService.get('/audit/event-types'),
    getEntityTrail: (entityType, entityId, page = 0, size = 25) =>
        apiService.get(`/audit/entity/${entityType}/${entityId}`, { page, size }),
};
